module.exports = __webpack_public_path__ + "static/media/experian.e684d652.jpg";